// this state name follows the naming in the './slice' `initialState`
const DISCOVER_PEOPLE_STATE = {
  SUGGEST: 'getSuggestFriends',
  SEARCH: 'getSearchPeople',
};

// eslint-disable-next-line import/prefer-default-export
export { DISCOVER_PEOPLE_STATE };
